import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "header-row d-none d-sm-flex row pt-3 row-divider" }
const _hoisted_3 = { class: "d-block col-md-2 ps-0 mb-4" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "d-sm-none" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-5 text-end" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-5 text-end" }
const _hoisted_10 = { class: "d-none d-sm-block col-md-2 pt-md-0 px-0 ps-md-4" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "d-none d-sm-block col-md-2 pt-md-0 px-0 ps-md-4" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "d-none d-md-block text-start" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "d-grid d-md-none col-md-1 pe-0" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "alert alert-info mt-2 mb-0",
  role: "alert"
}

import { ref, onMounted, computed, watch } from "vue";
import ProviderCostEstimator from "@/guiide/components/guiideplus/providers/ProviderCostEstimator.vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import { formatter } from "@/shared/ts/formatter";
import { ProviderCharges } from "../../ts/providerCharges";
import { app } from "../../ts/app";
import Monitoring from "@/guiide/ts/monitoring/monitoring";
import { useStore } from "vuex";

type ProviderInfo = { key: string, name: string, abbrevName: string, description: string[], subscript: string, charge: number, saving: number, image: string, url: string, eventName: string };


export default /*@__PURE__*/_defineComponent({
  __name: 'ProvidersList',
  props: {
    showCharges: { type: Boolean, default: true },
    title: { type: String, default: "Partners" },
    showCostComparisonAlert: { type: Boolean, default: false }
},
  setup(__props) {

const store = useStore();

const props = __props;

const providerCostEstimator = ref(null);
const providerCharges = ref<ProviderCharges|null>(null);
const providers = ref(new Array<ProviderInfo>());
const pensionProvidersInStore = computed(() => store.state.pensionProvidersForFindYourself);

onMounted(async () => {
  if (store.state.pensionProvidersForFindYourself == null || store.state.pensionProvidersForFindYourself.length == 0) {
      app.getPensionProviders();
  }

  if (props.showCharges) {
    providerCharges.value = await app.getProviderCharges();
  }
});

watch(
  [pensionProvidersInStore, providerCharges],
  ([newProviders, providerCharges]) => {
    if (newProviders.length == 0 || (props.showCharges && providerCharges == null)) {
      return;
    }

    for (const provider of newProviders) {
      let charge = { orgKey: "", amount: 0 };
      
      if (props.showCharges) {
        charge = providerCharges.charges.find(c => c.orgKey == provider.key);
      }

      const eventName = `LowCost${provider.key}`;

      providers.value.push(createProvider(
        provider.key,
        provider.name,
        provider.name,
        provider.description,
        provider.chargeNotePersonalComparison,
        charge.amount,
        provider.image,
        provider.url,
        eventName
      ));

      if (props.showCharges) {
        providerCostEstimator.value.invokeChangeEvent();
      }
    }
  }
);

const industryAverageCharge = computed<number>(() => providerCharges.value?.industryAverage ?? 0 );

function chargeRateChanged(chargeRate: number, cost: number) {
  for (const provider of providers.value) {
    provider.saving = getProviderSaving(provider.charge, cost);
  }
}

function createProvider(key: string, name: string, abbrevName: string, description: string[], subscript: string, charge: number, image: string, url: string, eventName: string): ProviderInfo {
  return {
    key: key,
    name: name,
    abbrevName: abbrevName,
    description: description,
    subscript: subscript,
    charge: charge,
    saving: 0,
    image: image,
    url: url,
    eventName: eventName
  };
}

function getProviderSaving(
      providerCost: null | number,
      industryCost: null | number
    ): null | number {
  if (providerCost == null || industryCost == null) {
    return null;
  }

  const saving = industryCost - providerCost;
  return saving;
}

function onVisitClicked(providerKey: string) {
  const provider = providers.value.find(p => p.key == providerKey);
  const potValue = store.state.retiree.pensionPots.presentValue;
  Monitoring.gaEvent(provider.eventName, potValue);
  window.open(provider.url, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showCharges)
      ? (_openBlock(), _createBlock(ProviderCostEstimator, {
          key: 0,
          ref_key: "providerCostEstimator",
          ref: providerCostEstimator,
          industryAverageCharge: industryAverageCharge.value,
          upperText: "Use the slider to compare your current providers total annual charges if you know this, or leave it as 1%, as that is a typical average total charges figure.",
          lowerText: "Don't know your current providers charges as they are not clear? Maybe you should ask them why they aren't!",
          onChargeRateChanged: chargeRateChanged
        }, null, 8, ["industryAverageCharge"]))
      : _createCommentVNode("", true),
    _createVNode(SubSection, {
      title: __props.title,
      showHelp: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-block col-md-2 ps-0" }, [
              _createElementVNode("p", { class: "text-start fw-bold px-0 mx-0" }, "Provider")
            ], -1)),
            (__props.showCharges)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-block col-md-2 pt-md-0 px-0 ps-md-4" }, [
                    _createElementVNode("p", { class: "text-end fw-bold px-0 mx-0" }, [
                      _createTextVNode("Charges"),
                      _createElementVNode("sup", null, "*")
                    ])
                  ], -1)),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-block col-md-2 pt-md-0 px-0 ps-md-4" }, [
                    _createElementVNode("p", { class: "text-end fw-bold px-0 mx-0" }, "Savings Possible")
                  ], -1))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["d-block pt-md-0 px-0 ps-md-4", __props.showCharges ? 'col-md-5' : 'col-md-9'])
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("p", { class: "text-start fw-bold px-0 mx-0" }, "May be suitable for", -1)
            ]), 2),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-block col-md-1 pe-0" }, null, -1))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (provider) => {
            return (_openBlock(), _createElementBlock("div", {
              key: provider.key,
              class: "row pt-3 row-divider"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: provider.image,
                  class: "w-100",
                  alt: provider.name
                }, null, 8, _hoisted_4)
              ]),
              (__props.showCharges)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-7 px-0 text-start" }, [
                          _createElementVNode("p", { class: "fw-bold" }, [
                            _createTextVNode("Lifetime Charges "),
                            _createElementVNode("sup", null, "*")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", null, _toDisplayString(_unref(formatter).formatCurrency(provider.charge)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-7 px-0 text-start" }, [
                          _createElementVNode("p", { class: "fw-bold" }, "Savings Possible")
                        ], -1)),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(provider.saving >= 0 ? 'text-success' : 'text-danger')
                            }, _toDisplayString(_unref(formatter).formatCurrency(provider.saving)), 3)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(formatter).formatCurrency(provider.charge)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, [
                        _createElementVNode("span", {
                          class: _normalizeClass(provider.saving >= 0 ? 'text-success' : 'text-danger')
                        }, _toDisplayString(_unref(formatter).formatCurrency(provider.saving)), 3)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["d-block pt-md-0 px-0 ps-md-4", __props.showCharges ? 'col-md-6' : 'col-md-9'])
              }, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(provider.description), 1),
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: ($event: any) => (onVisitClicked(provider.key))
                  }, "Visit our website", 8, _hoisted_16)
                ])
              ], 2),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "btn btn-primary btn-sm floatend m-0 mb-3",
                  onClick: ($event: any) => (onVisitClicked(provider.key))
                }, "Visit", 8, _hoisted_18)
              ])
            ]))
          }), 128))
        ]),
        (__props.showCostComparisonAlert)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[7] || (_cache[7] = [
              _createElementVNode("h5", { class: "alert-heading" }, [
                _createElementVNode("i", { class: "bi bi-info-circle text-muted fs-5 me-2" }),
                _createTextVNode("Compare your costs ")
              ], -1),
              _createElementVNode("p", { class: "mb-0" }, [
                _createTextVNode(" You can compare any provider's expected costs in £ terms based on your plan against your current provider in the provider page on our "),
                _createElementVNode("a", { href: "guiideplus" }, "Dashboard"),
                _createTextVNode(". ")
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    (__props.showCharges)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-start" }, [
            _createElementVNode("sup", null, "*"),
            _createElementVNode("small", null, " Charges are estimated based on your Guiide plan and are in respect of charges from your retirement date only. We have not considered any charges or possible savings before retirement. The charges are; ")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (provider) => {
            return (_openBlock(), _createElementBlock("p", {
              key: provider.key,
              class: "text-start"
            }, [
              _createElementVNode("small", null, _toDisplayString(provider.subscript), 1)
            ]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})